import { render, staticRenderFns } from "./SortResources.vue?vue&type=template&id=0ed8be6d"
import script from "./SortResources.vue?vue&type=script&lang=js"
export * from "./SortResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports